export default {
  BAndRText: "Libros y Reseñas",
  Srchbook: "Buscar por libro",
  offlisugg: "Sugerencias de Ofellio ",
  recentlyRated: "Recientemente calificados",



  // ReviewPage
  rewbtn1: "Zu lesen",
  rewbtn2: "Schreibe eine Bewertung",
  rewbtn3: "Verwenden für Book Duo",
  rateBook: "Bewerte dieses Buch",
  buyon: "Kaufen auf",
  Read: "Gelesen",
  reviewtext: "Bewertung",
  ratingtext: "Deine Bewertung",
  readon: "Gelesen auf",
  book: "Buch",
  ebook: "E-book",
  audiobook: "Audiobook",
  revTitle: "Título",
  submitbtn: "Enviar",


  // Book Duo Page
  yourbd: "Tu Book Duo",
  serchbook: "Buscar libro",
  DidText: "¿No encontraste tu libro? ¡Ingresa los detalles!",
  city: "Ciudad",
  type: "Tipo",
  lookigfr: "Busco",
  male: "Masculino",
  female: "Femenino",
  idk: "No me importa",
  agerg: "Rango de edad",
  language: "Idioma",
  detil: "Detalles ",
  optnal: "Opcional",
  lookiginsp: "Algunas sugerencias",
  suggbokduo: "Libros sugeridos para un Book Duo",
  seemoresugg: "Ver más sugerencias",
  bokcvr: "Portada del libro ",
  title: "Título",
  writer: "Escritor ",
  genre: "Género",
  upload: "Subir ",
  add: "Hinzufügen ",
  online: "En línea"
  , onlink: "Añade el enlace a la videollamada (Teams, Zoom, Google Meet, etc.)",
  noBookSelected: "No se ha seleccionado ningún libro",
  loading: "Cargando...",
  noResultsFound: "No se encontraron resultados",
  meetingLink: "Enlace de la reunión",
  noLimit: "Sin límite",
  languageTooltip: "Este es el idioma que los participantes hablarán durante el Book Duo.",
  languageTooltipBookClub: "Este es el idioma que los participantes hablarán durante el Book Club.",
  updating: "Actualizando...",
  publishing: "Publicando...",
  update: "Actualizar",
  noBooksFound: "No se encontraron libros bajo esta sugerencia para un 1:1.",
  wellDone: "¡Bien hecho!",
  bookDuoLive: "Tu Book Duo ya está activo.",
  willInformInterest: "¡Te informaremos cuando alguien muestre interés!",
  seeOn: "Ver en",
  map: "Mapa",


  // Book Club Page
  when: "Cuándo",
  time: "Hora ",
  age: "Edad",
  publsbtn: "Publicar ",
  day: "Día",
  month: "Mes",
  year: "Año",
  hour: "Hora",
  min: "Min",
  max: "Máx",
  selectTime: "Seleccionar hora",
  selectLanguage: "Seleccionar idioma",
  selectType: "Seleccionar tipo",
  inPerson: "Presencial",
  attendees: "Asistentes",
  eventDetails: "Detalles del evento",

  // Silent Reading Page
  where: "Dónde",
  venue: "Lugar",
  address: "Dirección",



// BookAnd Review page Event
  welc: "Bienvenido",
  memb: "Miembro",
  exploreText: "Explora y únete a los eventos disponibles o crea el tuyo propio.",
  sbybooks: "Buscar por título",
  month: "Mes",
  sortby: "Ordenar por",
  cbduo: "Crear Book Duo",
  smoreevent: "Ver más eventos",
  dowant: "¿Quieres crear tu propio evento?",
  ledAmbsdr: "Los Book Clubs y Silent Readings están guiados por Ambassadores.",
  bAnAmbsdor: "Hazte Ambassador",
  leadText: "para liderar uno o descubrir y unirte a",
  evtnear: "eventos disponibles cerca de ti.",
  BookDuoFirstText: `¿Buscas una conexión auténtica? ¡Un Book Duo es perfecto para ti!`,
  BookDuoSecondText: `Elige un libro, define el sexo y la franja de edad de la persona con la que quieres conectar y listo. Cuando alguien muestre interés, podréis chatear y organizar los detalles de vuestro encuentro uno a uno.`,

  BookClubFirstText: `Descubre clubes de lectura presenciales en tu zona o en línea, celebrados en entornos acogedores como cafés, bares u otros espacios cálidos, o mediante videollamadas.`,
  BookClubSecondText: `Cada Book Club de Ofellio admite hasta 8 participantes agrupados por edad para ofrecer una experiencia más cómoda. Un Ambassador de Ofellio modera la conversación para garantizar un ambiente dinámico e inclusivo.`,

  BookSilentFirstText: `En un ambiente tranquilo y confortable, las sesiones de Silent Reading ofrecen un respiro sereno para hasta 10 lectores.`,
  BookSilentSecondText: `Guiadas por un Ambassador de Ofellio, cada sesión te invita a llevar tu propio libro, leer en silencio y, si quieres, compartir la experiencia con otros en un entorno relajado.`,

  DuoBtnText: `Crear Book Duo`,
  ClubBtnText: `Crear Book Club`,
  SilentBtnText: `Crear Silent Reading`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Book Club",
  bookSilentTitle: "Silent Reading",



// BOOK_CLUB DUO SILENTREADING
  yownbook: "Tu propio libro",
  resetFilters: "Restablecer filtros",
  resetAll: "Restablecer todo",
  applyFilters: "Aplicar filtros",
  filters: "Filtros",
  full: "COMPLETO",
  booked: "Reservado",
  open: "Abierto",
  buyon: "Comprar en",
  gender: "Género",
  locatedin: "Ubicado en",
  aboutbook: `Sobre el libro`,
  readmore: `Leer más`,
  readless: `Leer menos`,
  details: "Detalles",
  totalspot: "Plazas totales",
  spotleft: "Plazas disponibles",
  join: "Unirse",
  share: "Compartir",
  cregistration: "Completa tu registro",
  registrationmsg: "Tu correo electrónico se compartirá con el Ambassador",
  welldone: "¡Bien hecho!",
  attending: "Asistirás a ",
  attendmsg: "Ahora puedes ver este evento en tu panel de Ofellio y chatear con tu Ambassador",
  thankyou: "¡Gracias!",
  thankmsg: "El organizador ya conoce tu interés y puede enviarte un mensaje para concretar los detalles de este Book Duo",

  // CHAT PAGE
  msgtext: "Mensajes ",
  vprofile: "Ver perfil",
  mute: "Silenciar",
  block: "Bloquear",
  unblock: "Desbloquear",
  report: "Reportar",

  // Setting Page
  pprofile: "Perfil personal",
  accnotifi: "Notificaciones",
  uploadp: "Subir foto",
  name: "Nombre",
  surname: "Apellido",
  dob: "Fecha de nacimiento",
  aboutme: "Sobre mí",
  country: "País",
  favgenre: "Géneros favoritos",
  asmedia: "Añade tus redes sociales a continuación",
  savechgbtn: "Guardar cambios",

  cypass: "Cambiar tu contraseña",
  cypasstext: "Cuando cambies tu contraseña, se cerrará automáticamente tu sesión en otros dispositivos",
  cpass: "Cambiar contraseña",
  cyemail: "Cambiar tu correo electrónico",
  cyemailtext: "Cuando cambies tu correo electrónico, se cerrará automáticamente tu sesión en otros dispositivos",
  cemail: "Cambiar correo electrónico",
  notifi: "Notificación ",
  emailmeab: "Envíame correos sobre",
  lastesttext: "Últimos libros populares",
  upcomtext: "Nuevos libros del próximo mes",
  baevent: "Libros, autores y eventos que me gustarían",
  newoff: "Nuevas funciones de Ofellio",

  curnpass: "Contraseña actual",
  newpass: "Nueva contraseña",
  cnewpass: "Confirmar nueva contraseña",
  curnemail: "Correo electrónico actual",
  newemail: "Nuevo correo electrónico",
  cnewemail: "Confirmar nuevo correo electrónico",
  delyacc: "Eliminar tu cuenta ",
  sorrytext: "¡Lamentamos mucho que quieras dejarnos!",
  suretext: "¿Estás seguro de que quieres hacer esto? ",
  decitext: "Si decides usar Ofellio nuevamente, necesitarás crear una nueva cuenta.",
  pass: "Contraseña",

  // meun
  jan: "Enero",
  feb: "Febrero",
  mar: "Marzo",
  apr: "Abril",
  may: "Mayo",
  jun: "Junio",
  jul: "Julio",
  aug: "Agosto",
  sep: "Septiembre",
  oct: "Octubre",
  nov: "Noviembre",
  dec: "Diciembre",
  // Month abbreviations
  monthAbbrJan: "Ene",
  monthAbbrFeb: "Feb",
  monthAbbrMar: "Mar",
  monthAbbrApr: "Abr",
  monthAbbrMay: "May",
  monthAbbrJun: "Jun",
  monthAbbrJul: "Jul",
  monthAbbrAug: "Ago",
  monthAbbrSep: "Sep",
  monthAbbrOct: "Oct",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Dic",
  cri: "Crimen",
  fic: "Ficción",
  grpnvl: "Novelas gráficas y manga",
  yng: "Jóvenes adultos y LGBTQ+",
  nonfic: "No ficción",
  scifan: "Ciencia ficción y fantasía",
  others: "Otros",
  morerec: "Más reciente",
  lessrec: "Menos reciente ",

  // HeaderProfil
  setg: "Configuración ",
  logout: "Cerrar sesión",


  // dashbords pages
  editprf: "Editar perfil",
  cbduo: "Crear Book Duo",
  joining: "Me estoy uniendo",
  bandrew: "Libros y Reseñas",
  upcomclub: "Próximos Book Clubs",
  upcomduo: "Próximos Book Duos",
  upcomsil: "Próximas Lecturas Silenciosas",
  allpst: "Todos los eventos pasados",
  edit: "Editar",
  going: "Voy",
  ngoing: "No voy",
  cancel: "Cancelar",

  level: "Nivel ",
  cbclub: "Crear Book Club",
  cbsil: "Crear Silent Reading",
  loyprog: "Programa de lealtad",
  mang: "Gestionar",
  attlist: "Lista de asistentes",
  event: "Cancelar RSVP",
  chatgroup: "Chatear con el grupo",
  chatambas: "Chatear con el Embajador",
  bookshelv: "Estanterías de",
  reviews: "Reseñas",

  // Leading Page
  ambassador: "Ambassador",
  member: "Miembro",
  level1: "Nivel 1",
  level2: "Nivel 2",
  level3: "Nivel 3",
  level4: "Nivel 4",
  toLevel: "a",
  highestLevel: "🎉 ¡Has alcanzado el nivel más alto!",
  editProfile: "Editar perfil",
  createBookClub: "Crear Book Club",
  createSilentReading: "Crear Silent Reading",
  createBookDuo: "Crear Book Duo",
  createEvent: "+ Crear evento",
  attendeesList: "Lista de asistentes",
  wantToRead: "Quiero leer",
  remove: "Eliminar",
  tbd: "Por determinar",
  full: "COMPLETO",
  yourOwnBook: "Tu propio libro",
  ageLabel: "Edad:",
  manage: "Gestionar",
  cancelRSVP: "Cancelar RSVP",
  imLeading: "Estoy liderando",
  imJoining: "Estoy participando",
  booksAndReviews: "Libros y Reseñas",
  loyaltyProgram: "Programa de fidelidad",
  upcomingBookClubs: "Próximos Book Clubs",
  upcomingSilentReadings: "Próximos Silent Readings",
  upcomingBookDuos: "Próximos Book Duos",
  noEventsToShow: "No hay eventos para mostrar.",
  wantToReadLower: "Quiero leer",
  readLower: "Leído",
  reviewsLower: "Reseñas",
  noRatedBooks: "Aún no has calificado ningún libro.",
  giftsDiscounts: "Regalos y descuentos en lectura",
  loyaltyDescription: "¡Cuanto más leas, más ganas! Disfruta de descuentos y beneficios mientras subes de nivel.",
  starterReader: "Lector principiante",
  starterReaderDesc: "Comienza tu viaje como Ambassador de Ofellio y comienza a liderar tus primeras experiencias de lectura.",
  starterReaderReward: "Reconocimiento temprano y acceso a futuros beneficios de Ambassador.",
  communityBuilder: "Constructor de comunidad",
  communityBuilderDesc: "Sigue conectando lectores y creando eventos de libros atractivos dentro de tu comunidad.",
  communityBuilderReward: "Acceso prioritario a nuevas funciones y actualizaciones exclusivas.",
  proHost: "Anfitrión profesional",
  proHostDesc: "Estás dando forma a momentos de lectura significativos e inspirando a otros a través de tus eventos.",
  proHostReward: "Invitaciones a próximas iniciativas de Ofellio y sorpresas especiales.",
  legend: "Leyenda",
  legendDesc: "Sigue inspirando a lectores de todo el mundo: tu liderazgo da forma a la comunidad de Ofellio.",
  legendReward: "Desbloquea reconocimiento exclusivo y beneficios en evolución.",
  attendees: "Asistentes",
  noAttendeesYet: "Aún no hay asistentes.",
  // Modal translations for add book manually
  booksCover: "Portada del libro",
  writerLabel: "Escritor",
  genreLabel: "Género",
  aboutTheBookLabel: "Sobre el libro",
  addButton: "Añadir",
  chatWithGroup: "Chatear con el grupo",
  cancelEvent: "Cancelar evento",
  cancelRSVPConfirm: "¿Estás seguro de que quieres cancelar tu RSVP?",
  cancelEventConfirm: "¿Estás seguro de que quieres cancelar este evento?",
  cancelRSVPEmail: "Se enviará un correo electrónico de cancelación al Ambassador.",
  cancelEventEmail: "Se enviará un correo electrónico de cancelación a los asistentes actuales.",

  // How It Works Section
  howOfellioWorks: "Cómo funciona Ofellio",
  howItWorksDesc: "Descubre nuevas formas de conectar a través de los libros: ya sea uno a uno, en grupo o en pacíficas sesiones de lectura silenciosa.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "¿Buscas una conexión personal? Elige un libro, selecciona la edad y el género preferido del compañero y comienza un viaje literario uno a uno.",
  bookClubTitle: "Book Club",
  bookClubDesc: "Únete a acogedores Book Clubs presenciales u online organizados en entornos acogedores. Cada grupo está facilitado por un Ambassador para garantizar una experiencia dinámica e inclusiva.",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "Disfruta de pacíficas sesiones de lectura silenciosa. Trae tu propio libro, relájate y comparte la tranquila alegría de leer juntos.",
  exploreThe: "Explora los",
  existingEvents: "eventos existentes",
  or: "o",
  createYourOwn: "crea el tuyo",
  joinOfellio: "Únete a Ofellio",
  signUp: "Regístrate",
  chooseYourCountry: "Elige tu país",
  joined: "unido",
  joinedCapitalized: "Unido",
  shareThisEvent: "Compartir este evento",
  linkVisibleAttendees: "Enlace visible solo para los asistentes",
  recentReviews: "Reseñas recientes",
  noReviewsAvailable: "No hay reseñas disponibles",
  writeAReview: "Escribir una reseña",
  yourRating: "Tu valoración",
  update: "Actualizar",
  aboutTheBook: "Acerca del libro",
  makeAChoiceForThisBook: "Haz una elección para este libro",
  howDidYouReadIt: "¿Cómo lo leíste?",
  noRating: "Sin valoración",
  reviewPublished: "Reseña publicada",
  useForBookDuo: "Usar para Book Duo",
  yourReview: "Tu reseña",
  addAShortTitle: "Añade un título corto",
  shareYourThoughts: "Comparte tus pensamientos sobre este libro...",
  send: "Enviar",
  bookclubLive: "¡Bien hecho! Tu Bookclub ya está activo y la gente puede unirse.",
  silentReadingLive: "¡Bien hecho! Tu Lectura Silenciosa ya está activa y la gente puede unirse.",
  dashboard: "Panel",

  // Day abbreviations
  dayMon: "Lun",
  dayTue: "Mar",
  dayWed: "Mié",
  dayThu: "Jue",
  dayFri: "Vie",
  daySat: "Sáb",
  daySun: "Dom",
  
  // Additional translations
  ambassadorLabel: "Ambassador:",
  createdBy: "Creado por:",
  youAreAttendingThis: "Estás participando en este",
  youCanNowSeeThisEvent: "Ahora puedes ver este evento en tu panel de Ofellio y chatear",
  withYourAmbassador: "con tu Ambassador",
  chatWithAmbassador: "Chatear con Ambassador",
  yourRequestHasBeenSent: "Tu solicitud ha sido enviada al ambassador",
  sentYouAMessage: "te envió un mensaje!",
  justJoinedYour: "se unió a tu",
  bookClubsAndSilentReadings: "Los Book Clubs y Silent Readings están guiados por Ambassadors.",
  becomeAnAmbassador: "Hazte Ambassador",
  toLeadOneOrExplore: "para liderar uno o descubrir y unirte a",
  eventsAvailable: "eventos disponibles.",
};
